<template>
  <span class="copy-text" :class="{ 'copy-text--inline': inline }">
    <template v-if="!iconOnly">
      <slot>{{ displayText }}</slot>
    </template>
    <i
      class="far fa-copy copy-text__icon"
      @click.stop="copyToClipboard"
      :data-tooltip="title"
    ></i>
  </span>
</template>

<script>
import copy from "copy-to-clipboard";
import { useToast } from "vue-toastification";

export default {
  name: "CopyText",
  props: {
    // The text to copy to clipboard
    text: {
      type: String,
      required: true,
    },
    // Label shown in the toast (e.g., "Staff ID" -> "Staff ID copied to clipboard")
    label: {
      type: String,
      default: "Text",
    },
    // Custom display text (if different from copy text)
    display: {
      type: String,
      default: null,
    },
    // Tooltip title for the icon
    title: {
      type: String,
      default: "Copy to clipboard",
    },
    // If true, renders inline without extra spacing
    inline: {
      type: Boolean,
      default: false,
    },
    // If true, only shows the copy icon (no text)
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    displayText() {
      return this.display || this.text;
    },
  },
  methods: {
    copyToClipboard() {
      copy(this.text);
      this.toast.success(`${this.label} copied to clipboard`, {
        timeout: 1500,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-text {
  &__icon {
    cursor: pointer;
    opacity: 0.6;
    margin-left: 0.25rem;
    position: relative;

    &:hover {
      opacity: 1;
    }

    // Fast CSS tooltip
    &[data-tooltip] {
      &::after {
        content: attr(data-tooltip);
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        padding: 5px 10px;
        background: rgba(0, 0, 0, 0.8);
        color: white;
        font-family: inherit;
        font-size: 0.75rem;
        font-weight: 400;
        font-style: normal;
        line-height: 1.4;
        border-radius: 0.25rem;
        white-space: nowrap;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.1s ease;
        pointer-events: none;
        margin-bottom: 6px;
        z-index: 100000;
      }

      &:hover::after {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  &--inline {
    display: inline;
  }
}
</style>
